import React from 'react';
//importing icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function Service({ service }) {
    return (
        <div className="card">
            <FontAwesomeIcon
                icon={service.icon}
                className="icon"
            />
            <h3>{service.name}</h3>
            <p>{service.description}</p>
        </div>
    )
}

export default Service
